import { Box } from "@mui/material";
import * as React from "react";
import CustomLink from "../link";
import InfoBoxContent from "./content";
import InfoBoxTitle from "./title";
import { InfoBoxProps } from "./types";
import "./styles.scss";

const classNameBase = "scd-info";

export default function InfoBox(props: InfoBoxProps): React.JSX.Element {
  const { title, content, link, href, onLinkClick } = props;

  return (
    <Box className={`${classNameBase}-box`} component="div">
      {title && <InfoBoxTitle>{title}</InfoBoxTitle>}
      <InfoBoxContent>{content}</InfoBoxContent>
      {link && (
        <CustomLink href={href} onClick={onLinkClick}>
          {link}
        </CustomLink>
      )}
    </Box>
  );
}
